import type { Entity, Timestamp } from '@marmon/shared/types/common';

export const EntitySettingTypes = ['analysis'] as const;
export type EntitySettingType = (typeof EntitySettingTypes)[number];

/**
 * System alerts that can be recorded once per cycle on an entity setting.
 * Add a key here when a new per-entity notification needs idempotency.
 */
export const EntityAlertKeys = ['analysis-expiration-warning'] as const;
export type EntityAlertKey = (typeof EntityAlertKeys)[number];

/**
 * Delivery record for one alert on this entity. `sentAt` is when the alert
 * was last sent, not which entity it belongs to.
 */
export type EntityAlertState = {
	sentAt: Timestamp;
};

/**
 * One user's settings for one entity. Stored at
 * `users/{userId}/entitySettings/{entityType}_{entityId}`.
 *
 * A missing document means system notifications are on and no alert has been sent.
 */
export interface EntitySetting extends Entity {
	entityType: EntitySettingType;
	entityId: string;

	/**
	 * `true` turns system notifications off for this entity.
	 * `false` follows the user's account-wide email preference.
	 */
	muteSystem: boolean;

	alerts: Partial<Record<EntityAlertKey, EntityAlertState>>;
}

export const EntitySettingsCollection = 'entitySettings' as const;

export type EntitySettingPatch = {
	muteSystem?: boolean;
	alert?: {
		key: EntityAlertKey;
		sentAt: Timestamp;
	};
};
